// extracted by mini-css-extract-plugin
export var alternateChatContainer = "project-list-module--alternateChatContainer--B-8Iy";
export var alternateImageContainer = "project-list-module--alternateImageContainer--zW8nQ";
export var alternateProjectContainer = "project-list-module--alternateProjectContainer--rZFC7";
export var chatBubble = "project-list-module--chatBubble--oxakN";
export var chatContainer = "project-list-module--chatContainer--eVxDN";
export var imageContainer = "project-list-module--imageContainer--OQkjO";
export var projectContainer = "project-list-module--projectContainer--Ip1T9";